import { createAction } from '@ngrx/store';

export const UserInit = createAction('[User] User Init');
